import { render, staticRenderFns } from "./a-list.vue?vue&type=template&id=4f80a540"
import script from "./a-list.vue?vue&type=script&lang=js"
export * from "./a-list.vue?vue&type=script&lang=js"
import style0 from "./a-list.vue?vue&type=style&index=0&id=4f80a540&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports